import type { PaymentMethodEntity } from '~/apiClient';
import { isCardPaymentMethod } from '~/types/paymentMethod.type';

// N.B. For now, it only supports the card payment method

type UsePaymentMethodInfoReturn = {
    paymentMethodLabel: ComputedRef<string | undefined>;
    expirationLabel: ComputedRef<string | undefined>;
    isExpired: ComputedRef<boolean>;
};

export const usePaymentMethodInfo = (paymentMethod: MaybeRefOrGetter<PaymentMethodEntity | undefined>): UsePaymentMethodInfoReturn => {
    const dayjs = useDayjs();
    const { tt } = useTypedI18n();
    const isExpired = computed(() => {
        const pm = toValue(paymentMethod);

        if (!pm || !isCardPaymentMethod(pm)) return false;

        const expirationStartOfMonth = dayjs()
            .year(pm.card.expYear)
            .month(pm.card.expMonth - 1) // DayJs month are 0-based
            .startOf('month');

        return dayjs().isAfter(expirationStartOfMonth, 'month');
    });

    return {
        paymentMethodLabel: computed(() => {
            const pm = toValue(paymentMethod);

            return pm && isCardPaymentMethod(pm) ? `${pm.card.brand} ****${pm.card.last4}` : undefined;
        }),

        isExpired,

        expirationLabel: computed(() => {
            const pm = toValue(paymentMethod);

            return pm && isCardPaymentMethod(pm)
                ? tt(isExpired.value ? 'paymentMethods.card.expired' : 'paymentMethods.card.expires', {
                      month: String(pm.card.expMonth).padStart(2, '0'),
                      year: pm.card.expYear,
                  })
                : undefined;
        }),
    };
};
